
export function getBabysittingModeFrom(modes, key, field, defaultValue) {
  const babysittingModes = modes ? modes.filter(mode => mode.key === key) : []
  if (babysittingModes && babysittingModes.length === 1) {
    return field ? babysittingModes[0][field] : babysittingModes[0]
  }
  return defaultValue || ''
}
